import { Routes, Route } from 'react-router-dom';
import { AppLayout } from './components/layout/AppLayout';
import { LandingPage } from './pages/LandingPage';
import { DashboardPage } from './pages/DashboardPage';
import { ProfileListPage } from './pages/ProfileListPage';
import { ProfilePage } from './pages/ProfilePage';
import { PropertyPage } from './pages/PropertyPage';
import { AnalysisPage } from './pages/AnalysisPage';
import { OfferPage } from './pages/OfferPage';
import { SharePage } from './pages/SharePage';

export function App() {
  return (
    <AppLayout>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/share" element={<SharePage />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/profiles" element={<ProfileListPage />} />
        <Route path="/profiles/:profileId" element={<ProfilePage />} />
        <Route path="/profiles/:profileId/properties/:propertyId" element={<PropertyPage />} />
        <Route path="/profiles/:profileId/properties/:propertyId/analyses/:analysisId" element={<AnalysisPage />} />
        <Route path="/profiles/:profileId/properties/:propertyId/offers/:offerId" element={<OfferPage />} />
      </Routes>
    </AppLayout>
  );
}
